var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { class: { titled: _vm.hasTitle } }, [
          _vm.hasTitle
            ? _c("div", [_c("h1", [_vm._v(_vm._s(_vm.title))])])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeFan(false)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _vm.subTitle ? _c("h3", [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function(item) {
              return _c("Item", { key: item.item.id, attrs: { item: item } })
            }),
            _vm._v(" "),
            _vm.type === "application"
              ? _c("div", [_c("NoExperienceInfo")], 1)
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("Button", {
              attrs: { text: "OK", disabled: !_vm.valid, icon: "checkmark" },
              on: {
                click: function($event) {
                  return _vm.closeFan(true)
                }
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }